var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573 1263 c-27 -77 -30 -80 -95 -102 -34 -12 -76 -30 -92 -40 -29 -19 -30 -19 -67 0 -52 26 -59 25 -104 -20 l-38 -40 21 -50 c19 -46 19 -51 4 -73 -9 -12 -27 -52 -39 -88 -23 -68 -26 -71 -85 -95 -38 -15 -38 -15 -38 -75 l0 -59 50 -18 c47 -17 51 -21 65 -68 9 -27 26 -70 39 -94 l23 -44 -21 -49 -20 -48 22 -22 c12 -12 23 -20 25 -17 10 11 127 219 127 225 0 4 -10 28 -22 53 -34 69 -37 187 -7 266 31 82 112 163 194 194 87 33 208 27 283 -14 70 -38 136 -112 162 -183 29 -76 25 -196 -8 -263 -12 -25 -22 -49 -22 -53 0 -6 117 -214 127 -225 2 -3 13 5 25 17 l22 22 -20 48 -21 49 23 44 c13 24 30 67 39 94 14 47 18 51 65 68 l50 18 0 59 c0 60 0 60 -37 75 -60 24 -63 27 -87 96 -13 37 -30 77 -39 89 -14 20 -13 26 5 71 l21 50 -38 40 c-45 45 -52 46 -104 20 -35 -19 -40 -19 -61 -4 -13 9 -55 28 -94 42 -67 25 -72 29 -87 71 l-17 45 -61 3 c-52 2 -62 0 -68 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 738 c-24 -22 -333 -547 -362 -615 -12 -28 -12 -38 0 -67 8 -19 23 -39 34 -45 28 -15 736 -15 764 0 11 6 26 26 34 45 12 29 12 39 0 66 -29 69 -338 594 -362 616 -14 12 -38 22 -54 22 -16 0 -40 -10 -54 -22z m78 -181 c16 -11 17 -28 14 -145 -2 -109 -6 -134 -20 -149 -17 -16 -19 -16 -35 0 -15 15 -19 40 -21 149 -3 117 -2 134 14 145 22 16 26 16 48 0z m11 -427 c0 -33 -2 -35 -35 -35 -29 0 -36 4 -38 23 -6 40 5 54 40 50 30 -3 33 -6 33 -38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskManagementIcon);
export default __webpack_public_path__ + "static/media/RiskManagementIcon.25b30bee7abaaf6e1291debe570f0feb.svg";
export { ForwardRef as ReactComponent };